(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  // Fallback accordion for footer link-list when DetailsDisclosure isn't present
  // on the page (native <details> handles open/close; JS only syncs desktop state).
  (function() {
    var syncFooterAccordions = function() {
      var isLargeScreen = window.matchMedia('(min-width: 769px)').matches;
      document.querySelectorAll('.footer-col--collapsed details.footer-menu').forEach(function(d) {
        if (isLargeScreen) {
          d.setAttribute('open', '');
        } else {
          // Only auto-close on mobile if it wasn't user-toggled this session
          if (d.dataset.userToggled !== 'true') {
            d.removeAttribute('open');
          }
        }
      });
    };

    document.addEventListener('DOMContentLoaded', function() {
      document.querySelectorAll('.footer-col--collapsed details.footer-menu').forEach(function(d) {
        d.addEventListener('toggle', function() { d.dataset.userToggled = 'true'; });
      });
      syncFooterAccordions();
    });
    window.addEventListener('resize', function() {
      clearTimeout(window.__footerAccordionResize);
      window.__footerAccordionResize = setTimeout(syncFooterAccordions, 150);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  // Fix mobile menu scroll issue
  document.addEventListener('DOMContentLoaded', function() {
    const mainMenu = document.querySelector('main-menu');
    const menuDisclosure = mainMenu?.querySelector('.main-menu__disclosure');
    
    if (menuDisclosure) {
      // Store the scroll position
      let scrollPosition = 0;
      
      const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.attributeName === 'open') {
            const isOpen = menuDisclosure.hasAttribute('open');
            const isMobile = !window.matchMedia(theme.mediaQueries.md).matches;
            
            if (isMobile) {
              if (isOpen) {
                // Store current scroll position
                scrollPosition = window.pageYOffset;
                // Lock body scroll
                document.body.style.overflow = 'hidden';
                document.body.style.position = 'fixed';
                document.body.style.top = `-${scrollPosition}px`;
                document.body.style.width = '100%';
              } else {
                // Unlock body scroll
                document.body.style.overflow = '';
                document.body.style.position = '';
                document.body.style.top = '';
                document.body.style.width = '';
                // Restore scroll position
                window.scrollTo(0, scrollPosition);
              }
            }
          }
        });
      });
      
      observer.observe(menuDisclosure, { attributes: true });
      
      // Clean up on window resize
      window.addEventListener('resize', function() {
        const isMobile = !window.matchMedia(theme.mediaQueries.md).matches;
        if (!isMobile) {
          document.body.style.overflow = '';
          document.body.style.position = '';
          document.body.style.top = '';
          document.body.style.width = '';
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
